import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_pick_task_by_taskidService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { taskid?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, ActualSourceLicensePlate?: { LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }, Order?: { LookupCode?: string }, Shipment?: { LookupCode?: string, LicensePlates?: { Id?: number, LookupCode?: string, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }[] }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string, Lot?: { LookupCode?: string } }[] }, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Status?: { Name?: string } }, ExpectedSourceLocation?: { Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { taskid?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, ActualSourceLicensePlate?: { LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }, Order?: { LookupCode?: string }, Shipment?: { LookupCode?: string, LicensePlates?: { Id?: number, LookupCode?: string, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }[] }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string, Lot?: { LookupCode?: string } }[] }, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Status?: { Name?: string } }, ExpectedSourceLocation?: { Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { taskid?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualSourceLicensePlateId?: number, ActualSourceLocationId?: number, ActualTargetLicensePlateId?: number, ExpectedPackagedAmount?: number, MaterialId?: number, OrderId?: number, OrderLineNumber?: number, ProjectId?: number, ShipmentId?: number, WarehouseId?: number, ActualSourceLicensePlate?: { LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }, Order?: { LookupCode?: string }, Shipment?: { LookupCode?: string, LicensePlates?: { Id?: number, LookupCode?: string, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string }[] }[] }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string }, LicensePlateContents?: { LicensePlateId?: number, ExpirationDate?: string, Lot?: { LookupCode?: string } }[] }, Material?: { LookupCode?: string, Project?: { LookupCode?: string } }, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string }, Status?: { Name?: string } }, ExpectedSourceLocation?: { Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      taskid?: number    }) {
      return false;
    }
}
